var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "YdDialog",
    {
      attrs: { visible: _vm.visibleLook, "append-to-body": "", width: "450px" },
      on: { close: _vm.closeLook },
    },
    [
      _vm.activeInfo
        ? _c(
            "div",
            {
              staticClass:
                "limit-coupon-page flex flex-col flex-align-center padding-bottom-20",
              staticStyle: { position: "relative" },
              style: {
                "background-image": "url(" + _vm.activeInfo.headImgUrl + ")",
                "background-color": _vm.activeInfo.backcolor,
                "background-size": "100% 216px !important",
                "background-position": "top !important",
                "background-repeat": "no-repeat",
              },
            },
            [
              _c("div", { staticClass: "coupon-box" }, [
                _vm.activeInfo.startTime
                  ? _c("div", { staticClass: "time-box font-14" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.activeInfo.startTime) +
                          "至" +
                          _vm._s(_vm.activeInfo.endTime) +
                          "\n      "
                      ),
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "color-bg-fff border-radius-20",
                    staticStyle: { padding: "0px 15px 15px 15px" },
                  },
                  _vm._l(_vm.activeInfo.couponInfoList, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: item.couponId,
                        staticClass: "coupon-item position-relative",
                      },
                      [
                        _c("img", {
                          staticClass: "img-bg",
                          attrs: {
                            src: "https://qiniu-business.ayundi.cn/activity/1728462012420_limit-coupon-bg.png",
                          },
                        }),
                        _c(
                          "div",
                          {
                            staticClass: "flex flex-align-center info-box",
                            attrs: { slot: "inner" },
                            slot: "inner",
                          },
                          [
                            _c("div", { staticClass: "limit-num font-12" }, [
                              _vm._v(" 每日" + _vm._s(item.totalNum) + "份 "),
                            ]),
                            _c("div", { staticClass: "left flex" }, [
                              _c("div", { staticClass: "price-box flex" }, [
                                item.type
                                  ? _c("div", { staticClass: "price" }, [
                                      _vm._v(
                                        _vm._s(
                                          item.type === 3
                                            ? item.discountsCondition * 10
                                            : item.discountsMoney
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "unit" }, [
                                  _vm._v(_vm._s(item.type === 3 ? "折" : "元")),
                                ]),
                              ]),
                              _c("div", { staticClass: "content" }, [
                                _c("div", { staticClass: "type" }, [
                                  _vm._v(_vm._s(item.name)),
                                ]),
                                _c("div", { staticClass: "tip" }, [
                                  _vm._v(_vm._s(item.extraMsg)),
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticClass: "stuats-box color-333 font-10",
                                  },
                                  [
                                    _vm.status === 1
                                      ? _c("div", [
                                          _c(
                                            "div",
                                            { staticClass: "font-color" },
                                            [_vm._v(_vm._s(item.str))]
                                          ),
                                          _vm._v("开始\n                  "),
                                        ])
                                      : item.state === 2
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex flex-align-center",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "schedule" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "schedule-num flex flex-justify-end",
                                                    style: {
                                                      width:
                                                        _vm.getProgress(index) +
                                                        "%",
                                                    },
                                                  },
                                                  [
                                                    _vm.getProgress(index) > 0
                                                      ? _c("img", {
                                                          staticClass: "icon",
                                                          style: {
                                                            right:
                                                              (_vm.getProgress(
                                                                index
                                                              ) > 4
                                                                ? -4
                                                                : -7) + "px",
                                                          },
                                                          attrs: {
                                                            src: "https://qiniu-business.ayundi.cn/activity/1728463943563_limit-coupon-progress.png",
                                                            mode: "aspectFit",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "margin-left-2" },
                                              [
                                                _vm._v(
                                                  "已抢" +
                                                    _vm._s(item.receiveNum || 0)
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : item.state === 3
                                      ? _c("div", [
                                          _vm._v(
                                            "\n                    距过期仅剩"
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "font-color" },
                                            [_vm._v(_vm._s(item.str))]
                                          ),
                                          _vm._v("天\n                  "),
                                        ])
                                      : item.state === 4
                                      ? _c("div", [_vm._v("已过期")])
                                      : item.state === 5
                                      ? _c("div", [
                                          item.str.length > 3
                                            ? _c("span", [_vm._v("下一场")])
                                            : _vm._e(),
                                          _c(
                                            "span",
                                            {
                                              class: {
                                                "font-color":
                                                  item.str.length > 3,
                                              },
                                            },
                                            [_vm._v(_vm._s(item.str))]
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                ),
                              ]),
                            ]),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "right flex flex-align-center flex-col flex-justify-center",
                              },
                              [
                                item.state === 1
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "coupon-btn padding-x-15 btn-1",
                                      },
                                      [_vm._v("未开始")]
                                    )
                                  : item.state === 2
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "coupon-btn padding-x-6 btn-2",
                                      },
                                      [_vm._v("立即领取")]
                                    )
                                  : item.state === 3
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "coupon-btn padding-x-15 btn-2",
                                      },
                                      [_vm._v("去使用")]
                                    )
                                  : _c(
                                      "div",
                                      {
                                        staticClass:
                                          "coupon-btn padding-x-15 btn-4",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            item.state == 4
                                              ? "已过期"
                                              : "已抢光"
                                          )
                                        ),
                                      ]
                                    ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "font-12 margin-top-3 color-999 num",
                                  },
                                  [
                                    _vm._v(
                                      "限领" +
                                        _vm._s(_vm.activeInfo.everyPersonTime) +
                                        "张"
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]),
              _c("div", { staticClass: "rule-box margin-top-10" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "color-bg-fff full-height padding-x-15 border-radius-20 rule-content",
                  },
                  [
                    _c("div", {
                      domProps: { innerHTML: _vm._s(_vm.activeInfo.rule) },
                    }),
                  ]
                ),
              ]),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }